import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import useScrollToTraining from "../utils/useScrollToTraining";

const Navbar = () => {

  const scrollToTraining = useScrollToTraining();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuType, setMenuType] = useState("");

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuOpen = (event, type) => {
    setAnchorEl(event.currentTarget);
    setMenuType(type);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuType("");
  };

  const navItems = [
    { label: "Home", path: "/" },
    { label: "All Courses" },
    // { label: "Services", path: "/services" },
    { label: "Training", path: "/" },
    { label: "About", path: "/about-us" },
    { label: "Contact", path: "/contact-us" },
  ];

  const courses = [
    { label: "Azure Data Engineering", path: "/course/azure-data-engineering-training" },
    { label: "GCP Data Engineering", path: "/course/gcp-professional-certification-training" },
    { label: "AWS Data Engineering", path: "/course/aws-data-engineering-training" },
    { label: "Snowflake Data Engineering", path: "/course/snowflake-data-engineering-training" },
    { label: "BigData Engineering", path: "/course/big-data-engineering-training" },
    { label: "Full Stack Data Engineering", path: "/course/full-stack-data-engineering-training" },
  ];

  const handleTrainingClick = () => scrollToTraining();

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(8px)", // Soft blur effect
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          zIndex: 1100,
        }}
      >
        {/* Notification Bar */}
        <Box
          sx={{
            background: "#0F2656",
            color: "white",
            textAlign: "center",
            py: 1,
            fontSize: "0.9rem",
          }}
        >
          New Batch on Azure Starts Every Week. Contact us today!
        </Box>

        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Logo */}
          <Typography
            variant="h6"
            component={Link} // Use Link component
            to="/" // Navigate to home
            sx={{
              fontWeight: "bold",
              fontSize: "1.5rem",
              cursor: "pointer",
              textDecoration: "none", // Remove default link underline
              background: "linear-gradient(45deg, #ffcc00, #ff33cc)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Cloud UpSkill
          </Typography>

          {/* Navbar Items */}
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            {navItems.map((item) => {
              if (item.label === "Training") {
                return (
                  <Button
                    key="Training"
                    sx={menuButtonStyles}
                    onClick={handleTrainingClick}
                  >
                    Training
                  </Button>
                );
              }

              return (
                <Button
                  key={item.label}
                  sx={menuButtonStyles}
                  component={Link}
                  to={item.path}
                  endIcon={item.label === "All Courses" ? <ExpandMoreIcon /> : null}
                  onClick={(e) => {
                    if (item.label === "All Courses") {
                      handleMenuOpen(e, "courses");
                    }
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </Box>

          {/* Dropdown Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            sx={{
              "& .MuiPaper-root": {
                background: "#FFFFFF",
                color: "#333333",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              },
            }}
          >
            {courses.map((item) => (
              <MenuItem
                key={item.label}
                component={Link}
                to={item.path}
                onClick={handleMenuClose}
                sx={{ "&:hover": { background: "#007FFF", color: "white" } }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>

          {/* Mobile Menu Button */}
          <IconButton
            edge="end"
            sx={{ display: { xs: "block", md: "none" }, color: "#333333" }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Spacer for fixed navbar */}
      <Toolbar sx={{ mt: "38px" }} />

      {/* Drawer (for mobile navigation) */}
      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
        <List sx={{ width: 250, background: "#FFFFFF", height: "100vh" }}>
          {navItems.map((item) => (
            <ListItem key={item.label} disablePadding>
              <ListItemButton
                component={Link}
                to={item.path}
                onClick={handleDrawerToggle}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: "1rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#333333",
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

const menuButtonStyles = {
  color: "#333333",
  fontSize: "1rem",
  fontWeight: "bold",
  mx: 1,
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    color: "#007FFF",
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: "5px",
    transform: "scale(1.05)", // Slight scale effect on hover
  },
};

export default Navbar;
